import { ILinks, IMainNavigation, ISocialLinks } from '../components/complex/footer/common/ICommon';
import { IFooter, ISocial, ISubFooter } from '../components/complex/footer/IFooter';
import { ISiteMap, SiteMap } from '../services/content';
import { INotification, ISiteLogo } from '../types';

export function unwrapPageHeader(response: any): any {
  let content:any = {};
  if (response && response[0]) {
    let contentHolder = response[0];
    if (contentHolder[0]) {
      content = contentHolder[0];
      content.logo = { url: content.logo?.url ,alt: content?.alternate_text};
    }
  }
  return content;
}

export function unwrapNotification(notification: any): INotification {
  return {
    notificationProps: notification,
  };
}

export function unwrapPageFooter(footer: any, SITE_MAP: ISiteMap): IFooter {
  const footerItems: IFooter = {
    disclaimer: '',
    mainNavigation: [],
    bottomNavigationLinks: [],
    social: { description: '', header: '', socialLinks: [], displaySocialMedia: true },
    subFooter: { copyright: '', links: [] },
    siteFooterlogo: { url: '' },
  };
  footerItems.mainNavigation = unwrapFooterMainNavigation(
    footer?.navigation_menu?.[0]?.main_navigation,
    SITE_MAP,
  );
  footerItems.bottomNavigationLinks = unwrapFooterMainNavigation(
    footer?.bottom_navigation_links?.[0]?.main_navigation,
    SITE_MAP,
  );
  footerItems.social = unwrapFooterSocial(footer?.social_media_content);
  footerItems.disclaimer = footer?.disclaimer?.children[0]?.children[0]?.text;
  footerItems.subFooter = unwrapSubFooter(footer?.copyright_strip, SITE_MAP);
  return footerItems;
}

function unwrapFooterMainNavigation(
  navigationList: any,
  SITE_MAP: ISiteMap,
): Array<IMainNavigation> {
  const navigationItems: Array<IMainNavigation> = [];
  navigationList.map((item: any) => {
    navigationItems.push({
      navigationHeader: item.navigation_header_text,
      subLinks: unwrapNavigationLinks(item?.menu_columns?.[0]?.sub_nav_links, SITE_MAP),
    });
  });
  return navigationItems;
}
function unwrapNavigationLinks(navlinks: any, SITE_MAP: ISiteMap): Array<ILinks> {
  const navlinksItem: Array<ILinks> = [];
  navlinks.map((item: any) => {
    navlinksItem.push({
      label: item.display_text,
      url: SITE_MAP[SiteMap.SITE_MAP_LINK][item.internal_site_url[0]?.uid]?.url,
      action: !SITE_MAP[SiteMap.SITE_MAP_LINK][item.internal_site_url[0]?.uid]?.url
        ? SITE_MAP[SiteMap.SITE_MAP_DIALOG][item.internal_site_url[0]?.uid]?.action
        : null,
      isExternal: SITE_MAP[SiteMap.SITE_MAP_LINK][item.internal_site_url[0]?.uid]?.isExternal || false,  
    });
  });
  return navlinksItem;
}

function unwrapFooterSocial(social: any): ISocial {
  const socialItems: ISocial = {
    description: '',
    header: '',
    socialLinks: [],
    displaySocialMedia: true
  };
  socialItems.displaySocialMedia = social?.display_social_media;
  socialItems.header = social?.header_social_media?.children[0]?.children[0]?.text;
  socialItems.description = social?.message_social_media?.children[0]?.children[0]?.text;
  socialItems.socialLinks = unwrapFooterSocialLinks(social?.socialmediaicons?.icon);
  return socialItems;
}

function unwrapFooterSocialLinks(socialLinks: any): Array<ISocialLinks> {
  const socialLinksItems: Array<ISocialLinks> = [];
  socialLinks.map((item: any) => {
    socialLinksItems.push({
      ariaLabel: item.aria_label,
      icon: item.global_field.iconcode,
      iconRoute: item.external_link_route,
    });
  });
  return socialLinksItems;
}

function unwrapSubFooter(subFooter: any, SITE_MAP: ISiteMap): ISubFooter {
  const subFooterItems: ISubFooter = {
    links: [],
    copyright: '',
  };
  subFooterItems.copyright = subFooter?.copyright_text?.children[0]?.children[0]?.text;
  subFooterItems.links = unwrapNavigationLinks(subFooter?.copyright_urls, SITE_MAP);
  return subFooterItems;
}
